// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"buttonsWrapper--JFYJO","spinnerButton":"spinnerButton--DhITV"};